import {Component, OnInit, ChangeDetectorRef, AfterViewInit} from '@angular/core';
import {StorageService} from '../../Services/storage.service';
import {DataService} from '../../Services/data.service';
import {DateFilterService} from '../../Services/dateFilter.service';
import {DatePipe} from '@angular/common';
import {StatisticsItem} from '../common/widget/statistics/statistics.model';
import {CustomArrayFilterPipe} from '../common/custom-array-filter.pipe';
import {Title} from '@angular/platform-browser';
import {BsToastService} from '../../Services/bs-toast-service';
import {ChartOptionsModel} from '../../DataModels/apexchart.model';
import {Series} from '../../DataModels/series-data-model';
import {HelperService} from '../../Services/helper/helper.service';
import {firstValueFrom} from 'rxjs';


@Component({
  selector: 'app-financial-dashboard',
  templateUrl: './financial-dashboard.component.html',
  styleUrls: ['./financial-dashboard.component.css'],
  standalone: false
})
export class FinancialDashboardComponent implements OnInit, AfterViewInit {

  public chartOptions: Partial<ChartOptionsModel> = {};

  vm: any = {};
  queryData: any[];
  isLoaded = false;

  public statisticsData: StatisticsItem[] = [];

  constructor(
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private dateFilter: DateFilterService,
    private datePipe: DatePipe,
    private changeDetectorRef: ChangeDetectorRef,
    private titleService: Title,
    private helperService: HelperService) {

    this.vm.request = {};
    this.vm.request.labels = [];
    this.vm.balanceSheet = [];
    this.vm.reminderNew = {};
    this.vm.trending = {};
    this.vm.currentAssets = this.vm.totalRevenue = 0;
    this.vm.cutOffAlert = true;
    this.vm.addReminder = false;
    this.vm.request.includeForecast = false;
    this.vm.incomeStatementForWidgets = [];
    this.vm.balanceSheetForWidgets = [];
    this.vm.statisticsForWidgets = [];

    // minimum empty config for ApexCharts object - do this or get t error.
    this.chartOptions = {
      // theme: {
      //   mode: 'dark',
      //   palette: 'palette7',
      // },
      series: [
        {
          name: ' ',
          data: [] // Empty data array
        }
      ],
      grid: {},
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: true // Enable the toolbar/menu
        },
        background: 'transparent',
        zoom: {
          enabled: true
        },
      },
      title: {
        text: ' '
      },
      xaxis: {
        type: 'category',
        tickPlacement: 'on',
        categories: [],
        axisBorder: {},
        axisTicks: {},
        labels: {
          style: {}
        }
      },
      dataLabels: {
        enabled: false
      }
    };
  }

  ngOnInit() {
    this.titleService.setTitle($localize`:Dashboard@@Dashboard:Dashboard`);

    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));

    if (this.vm.Preferences.default_company_id) {
      this.vm.request.company_id = this.vm.Preferences.default_company_id;
    }


    this.getTableData('company', '?state=active&pageNumber=0&pageSize=9999999', 'company', (value: { Data: any[]; }) => {
      this.vm.company = value.Data;
      console.log('company list response: ', value.Data);
      console.log('default_company_id from Preferences: ', this.vm.request.company_id);
      let chosenFound = false;
      value.Data.forEach(comp => {
        if (comp.id == this.vm.request.company_id) {
          chosenFound = true;
        }
      });
      if (!chosenFound) {
        console.log('company_id ' + this.vm.request.company_id + ' not found in company list - resetting to empty, dashboard widgets will not be scoped to a company');
        this.vm.request.company_id = '';
      }

      this.init().then((result) => {
        // Handle successful result
        // console.log(result);
      })
        .catch((error) => {
          // Handle error
        })
        .finally(() => {
          // Code to execute after the promise is either resolved or rejected
          // console.log('Promise completed');
          // console.log(result);
          this.isLoaded = true;
          // this.updateFinancialChartData();
        });
      // this.isLoaded = true;
    });
  }

  ngAfterViewInit() {
    const applyThemeColors = () => {
      this.applyChartThemeColors();
    };

    if (document.readyState === 'complete') {
      requestAnimationFrame(applyThemeColors);
    } else {
      window.addEventListener('load', () => requestAnimationFrame(applyThemeColors), {once: true});
    }

    // console.log('ngAfterViewInit', this.chart);
    // this.chart.subtitle.text = 'This is the input test SUBTITLE from init';
  }

  private applyChartThemeColors(): void {
    const primary = this.helperService.getColorVariable('primary');
    if (!primary) {
      return;
    }

    this.chartOptions = {
      ...this.chartOptions,
      grid: {
        ...this.chartOptions.grid,
        borderColor: primary,
      },
      xaxis: {
        ...this.chartOptions.xaxis,
        axisBorder: {
          ...this.chartOptions.xaxis?.axisBorder,
          color: primary,
        },
        axisTicks: {
          ...this.chartOptions.xaxis?.axisTicks,
          color: primary,
        },
        labels: {
          ...this.chartOptions.xaxis?.labels,
          style: {
            ...this.chartOptions.xaxis?.labels?.style,
            colors: primary,
          }
        }
      }
    };
    this.changeDetectorRef.detectChanges();
  }

  widgetLoaderIncomeStatement() {
    // NOTE: do NOT reset this.statisticsData here. queryIncomeStatement() and
    // queryBalanceSheet() are kicked off in parallel (independent HTTP calls) from init(),
    // so whichever resolves first would have its widgets wiped out when the other loader
    // ran this reset afterward - this was causing the balance sheet widgets to intermittently
    // not appear on first load, depending on which response came back first.
    this.statisticsData = this.statisticsData.filter(
      (s) => s.report !== '/transaction-reports/income-statement'
    );

    for (const obj of this.vm.incomeStatementForWidgets) {
      if (!obj) {
        continue;
      }
      if (obj.id == 'revenue') {
        this.createIncomeStatementWidgetData('revenue', 'Revenue', 'Net Income');
      }
      if (obj.id == 'costs-of-sales') {
        this.createIncomeStatementWidgetData('costs-of-sales', 'Cost of Sales', 'COGS');
      }
      if (obj.id == 'margin') {
        this.createIncomeStatementWidgetData('margin', 'Margin', 'Margin');
      }
      if (obj.id == 'operating-expenses') {
        this.createIncomeStatementWidgetData('operating-expenses', 'Operating Expenses', 'Operating Expenses');
      }
      if (obj.id == 'net-income') {
        this.createIncomeStatementWidgetData('net-income', 'Net Income', 'Net Income');
      }
    }
  }

  widgetLoaderBalanceSheet() {
    // balance sheet items
    // Only remove this loader's own previously-added widgets (see note in
    // widgetLoaderIncomeStatement()) so the two parallel loaders don't stomp on each other.
    this.statisticsData = this.statisticsData.filter(
      (s) => s.report !== '/transaction-reports/balance-sheet'
    );

    for (const obj of this.vm.balanceSheetForWidgets) {
      if (!obj) {
        continue;
      }
      if (obj.id == 'cash-bank') {
        this.createBalanceSheetWidgetData('cash-bank', 'Cash', 'Cash');
      }
      if (obj.id == 'inventory') {
        this.createBalanceSheetWidgetData('inventory', 'Inventory', 'Inventory');
      }
      if (obj.id == 'accounts-receivable') {
        this.createBalanceSheetWidgetData('accounts-receivable', 'Accounts Receivable', 'Accounts Receivable');
      }
      if (obj.id == 'accounts-payable') {
        this.createBalanceSheetWidgetData('accounts-payable', 'Accounts Payable', 'Accounts Payable');
      }
      if (obj.id == 'current-assets') {
        this.createBalanceSheetWidgetData('current-assets', 'Current Assets', 'Current Assets');
      }
      if (obj.id == 'current-liabilities') {
        this.createBalanceSheetWidgetData('current-liabilities', 'Current Liabilities', 'Current Liabilities');
      }
      if (obj.id == 'working-capital') {
        this.createBalanceSheetWidgetData('working-capital', 'Working Capitol', 'Working Capitol');
      }
    }
  }

  createIncomeStatementWidgetData(dataKey: string, widgetName: string, widgetDescription: string) {
    let dataValue: any = 0.00;
    let subtotalPercent: any = 0.00;
    let percentChange: any = 0.00;
    let priorAmount: any = 0.00;
    let trend = 'flat';
    let reportLink = '';

    const row = this.FilterObject(this.vm.incomeStatementForWidgets, {id: dataKey}, true)[0];
    if (row) {
      dataValue = row.amount;
      subtotalPercent = row.percent_of_subtotal ?? 0;
      percentChange = row.percent_change ?? 0;
      priorAmount = row.prior_amount ?? 0;
      trend = row.trend || 'flat';
    }
    reportLink = '/transaction-reports/income-statement';

    const trendInfo = this.getTrendDisplay(trend);

    const widgetRec: StatisticsItem = {
      id: 2,
      title: widgetName,
      description: widgetDescription,
      stats: parseFloat(dataValue).toFixed(2),
      trendNumber: parseFloat(percentChange).toFixed(2) + '%',
      trendTime: 'vs. prior period',
      subtotalPercent: parseFloat(subtotalPercent).toFixed(2) + '%',
      subtotalLabel: '% of Revenue',
      priorAmount: parseFloat(priorAmount).toFixed(2),
      icon: 'mdi mdi-book-open-outline',
      trendIcon: trendInfo.icon,
      trendTextClass: trendInfo.textClass,
      badgeVariant: trendInfo.badgeVariant,
      report: reportLink,
      reportFromDate: this.vm.request.fromDate,
      reportToDate: this.vm.request.toDate
    };
    this.statisticsData.push(widgetRec);
  }

  private getTrendDisplay(trend: string): { icon: string, textClass: string, badgeVariant: string } {
    switch (trend) {
      case 'up':
        return {icon: 'mdi mdi-arrow-up-bold', textClass: 'text-success', badgeVariant: 'badge-success-lighten'};
      case 'down':
        return {icon: 'mdi mdi-arrow-down-bold', textClass: 'text-danger', badgeVariant: 'badge-danger-lighten'};
      default:
        return {icon: 'mdi mdi-arrow-right-bold', textClass: 'text-muted', badgeVariant: 'badge-secondary-lighten'};
    }
  }

  createBalanceSheetWidgetData(dataKey: string, widgetName: string, widgetDescription: string) {
    let dataValue: any = 0.00;
    let subtotalPercent: any = 0.00;
    let percentChange: any = 0.00;
    let priorAmount: any = 0.00;
    let trend = 'flat';
    const reportLink = '/transaction-reports/balance-sheet';

    const row = this.FilterObject(this.vm.balanceSheetForWidgets, {id: dataKey}, true)[0];
    if (row) {
      dataValue = row.amount;
      subtotalPercent = row.percent_of_subtotal ?? 0;
      percentChange = row.percent_change ?? 0;
      priorAmount = row.prior_amount ?? 0;
      trend = row.trend || 'flat';
    }

    const trendInfo = this.getTrendDisplay(trend);

    const widgetRec: StatisticsItem = {
      id: 2,
      title: widgetName,
      description: widgetDescription,
      stats: parseFloat(dataValue).toFixed(2),
      trendNumber: parseFloat(percentChange).toFixed(2) + '%',
      trendTime: 'vs. prior period',
      subtotalPercent: parseFloat(subtotalPercent).toFixed(2) + '%',
      subtotalLabel: '% of Current Assets',
      priorAmount: parseFloat(priorAmount).toFixed(2),
      icon: 'mdi mdi-book-account-outline',
      trendIcon: trendInfo.icon,
      trendTextClass: trendInfo.textClass,
      badgeVariant: trendInfo.badgeVariant,
      report: reportLink,
      reportFromDate: this.vm.request.fromDate,
      reportToDate: this.vm.request.toDate
    };
    this.statisticsData.push(widgetRec);
  }

  private getTableData(apiEndPoint, params, cacheName, fun) {
    this.tableDataService.getApiListData(apiEndPoint, params).subscribe((result: any) => {
      fun(result);
    });
  }

  async init(): Promise<any> {
    this.vm.request.type = 'line';

    // Reset here (once, before kicking off the two parallel queries below) rather than
    // inside each individual widget loader, so a refresh/re-init starts from a clean slate
    // without the two loaders racing to clear each other's results.
    this.statisticsData = [];

    this.setDateLookups();

    // // if we don't know company don't run the fetch of data
    // if (this.vm.company && this.vm.company?.length > 0) {
    //   this.notification.showWarningToast('No Company Selected, so not showing Dashboard Data');
    //   return;
    // }

    this.queryIncomeStatement().then();
    this.queryBalanceSheet().then();
    await this.updateFinancialChartData();
  }

  setDateLookups() {
    const months = [
      $localize`:Jan @@jan:Jan`,
      $localize`:Feb @@feb:Feb`,
      $localize`:Mar @@mar:Mar`,
      $localize`:Apr @@apr:Apr`,
      $localize`:May @@may:May`,
      $localize`:Jun @@jun:Jun`,
      $localize`:Jul @@jul:Jul`,
      $localize`:Aug @@aug:Aug`,
      $localize`:Sep @@sep:Sep`,
      $localize`:Oct @@oct:Oct`,
      $localize`:Nov @@nov:Nov`,
      $localize`:Dec @@dec:Dec`
    ];

    if (this.vm.request.toDate) {

      const d = new Date(this.vm.request.toDate);
      let tempMonth = d.getMonth();
      let columns: number;
      if (this.vm.request.includeForecast) {
        columns = 7;
        if (tempMonth === 11) {
          tempMonth = 1;
        } else if (tempMonth === 10) {
          tempMonth = 0;
        } else {
          tempMonth += 2;
        }
      } else {
        columns = 5;
      }
      for (let x = columns; x > -1; x--) {
        let fc = '';
        if (x > 5) {
          fc = ' *FC';
        }
        this.vm.request.labels[x] = months[tempMonth] + fc;
        tempMonth -= 1;
        if (tempMonth < 0) {
          tempMonth = 11;
        }
      }
    } else {
      let d = new Date();
      d = new Date(d.getFullYear(), d.getMonth() + 1, 0);
      let tempMonthStr: string;

      if ((d.getMonth() + 1) < 10) {
        tempMonthStr = '0' + (d.getMonth() + 1);
      } else {
        tempMonthStr = '' + (d.getMonth() + 1);
      }

      // if (!this.vm.request.toDate) {
      this.vm.request.toDate = tempMonthStr + '/' + d.getDate() + '/' + d.getFullYear();
      // }

      let tempMonth = d.getMonth();
      let columns: number;
      if (this.vm.request.includeForecast) {
        columns = 7;
        if (tempMonth === 11) {
          tempMonth = 1;
        } else if (tempMonth === 10) {
          tempMonth = 0;
        } else {
          tempMonth += 2;
        }
      } else {
        columns = 5;
      }
      for (let x = columns; x > -1; x--) {
        let fc = '';
        if (x > 5) {
          fc = ' *FC';
        }
        this.vm.request.labels[x] = months[tempMonth] + fc;
        tempMonth -= 1;
        if (tempMonth < 0) {
          tempMonth = 11;
        }
      }
    }

    let date = new Date();
    date = new Date(date.getFullYear(), date.getMonth(), 1);
    date.setMonth(date.getMonth() + 1);
    date.setDate(date.getDate() - 1);

    if (!this.vm.request.fromDate) {
      this.vm.toDateSelect = [];
      this.vm.fromDateSelect = [];
      for (let x = 0; x < 38; x++) {
        const tempName = date.getFullYear() + ' ' + months[date.getMonth()];
        let tempMonthStr: string;
        if ((date.getMonth() + 1) < 10) {
          tempMonthStr = '0' + (date.getMonth() + 1);
        } else {
          tempMonthStr = '' + (date.getMonth() + 1);
        }
        const tempFromDate = tempMonthStr + '/' + '01/' + date.getFullYear();
        this.vm.fromDateSelect.push({date: tempFromDate, name: tempName});
        if (x < 26) {
          const tempToDate = tempMonthStr + '/' + date.getDate() + '/' + date.getFullYear();
          this.vm.toDateSelect.push({date: tempToDate, name: tempName});
          // console.log('fromDate:' + this.vm.fromDateSelect);
          // console.log('toDate:' + this.vm.toDateSelect);
        }
        date = new Date(date.getFullYear(), date.getMonth(), 1);
        date.setDate(date.getDate() - 1);
      }
    }
  }

  async queryIncomeStatement(): Promise<any> {

    // if (this.vm.request.company_id == '') {
    //   this.notification.showWarningToast('No Company Selected, so not showing Dashboard Data');
    //   return;
    // }

    if (this.vm.request.toDate && !this.vm.request.fromDate) {
      const d = new Date(this.vm.request.toDate);
      d.setMonth(d.getMonth() - 3);
      d.setDate(1);
      this.vm.request.fromDate = this.datePipe.transform(d, 'MM/dd/yyyy');
    }

    let paramString = '';
    paramString += 'toDate=' + ((this.vm.request.toDate) ? this.dateFilter.GetDateFormat(this.vm.request.toDate) : '');
    paramString += '&fromDate=' + ((this.vm.request.fromDate) ? this.dateFilter.GetDateFormat(this.vm.request.fromDate) : '');
    paramString += '&company_id=' + ((this.vm.request.company_id) ? this.vm.request.company_id : '');

    console.log('DashboardIncomeStatement request params: ?' + paramString);

    this.tableDataService.getData('DashboardIncomeStatement', '?' + paramString).subscribe((result: any[]) => {
      this.vm.incomeStatement = [];
      this.vm.incomeStatement = result;

      this.vm.incomeStatementForWidgets = result;
      console.log('DashboardIncomeStatement response: ', result);

      // this.calcTotalRevenue();
      this.widgetLoaderIncomeStatement();
    });

  }

  async queryBalanceSheet(): Promise<any> {

    // if (this.vm.request.company_id == '') {
    //   this.notification.showWarningToast('No Company Selected, so not showing Dashboard Data');
    //   return;
    // }

    if (this.vm.request.toDate && !this.vm.request.fromDate) {
      const d = new Date(this.vm.request.toDate);
      d.setMonth(d.getMonth() - 3);
      d.setDate(1);
      this.vm.request.fromDate = this.datePipe.transform(d, 'MM/dd/yyyy');
    }

    let paramString = '';
    paramString += 'toDate=' + ((this.vm.request.toDate) ? this.dateFilter.GetDateFormat(this.vm.request.toDate) : '');
    paramString += '&fromDate=' + ((this.vm.request.fromDate) ? this.dateFilter.GetDateFormat(this.vm.request.fromDate) : '');
    paramString += '&company_id=' + ((this.vm.request.company_id) ? this.vm.request.company_id : '');

    console.log('DashboardBalanceSheet request params: ?' + paramString);

    this.tableDataService.getData('DashboardBalanceSheet', '?' + paramString).subscribe((result: any[]) => {
      this.vm.balanceSheet = result;

      this.vm.balanceSheetForWidgets = result;
      console.log('DashboardBalanceSheet response: ', result);

      // this.calcCurrentAssets();
      this.widgetLoaderBalanceSheet();
    });
  }

  refreshData() {
    this.notification.showSuccessToast('Updated');
    this.updateDashboard();
    this.updateFinancialChartData();
  }

  updateDashboard() {
    this.isLoaded = false;
    this.init().then((x) => {
      this.isLoaded = !x;
    });
  }

  async updateFinancialChartData() {

    if (this.vm.request.company_id == null) {
      this.notification.showWarningToast('No Company Selected, so not showing Dashboard Data');
      return;
    }

    let paramString = '';
    // TODO just so we have test data remove when data more current
    paramString += '&fromDate=' + new Date('01/01/2018').toISOString();
    // paramString += '&fromDate=' + new Date(this.vm.request.fromDate).toISOString();
    paramString += '&toDate=' + new Date(this.vm.request.toDate).toISOString();
    paramString += '&company_id=' + this.vm.request.company_id;

    console.log('Trending/GetAllFinancialTrending request params: ?' + paramString);

    const result: any = await firstValueFrom(
      this.tableDataService.getData('Trending/GetAllFinancialTrending', '?' + paramString)
    );

    console.log('Trending/GetAllFinancialTrending response: ', result);

    // be sure we have data in the range
    if (!result.data) {
      this.notification.showWarningToast('No Chart data found for the selected date range');
      return;
    }

    // lets just chart int - deci accuracy not needed.
    result.data.forEach((item) => {
      item.data = item.data.map((dataPoint: number) => Math.floor(dataPoint / 1000)); // Ensure in-place rounding
    });

    this.chartOptions = {
      ...this.chartOptions,
      series: result.data,
      title: {
        text: 'Financial Overview (in thousands)',
        align: 'center'
      },
      subtitle: {
        text: this.vm.request.fromDate + ' - ' + this.vm.request.toDate,
        align: 'center'
      },
      xaxis: {
        categories: result.xaxis.categories,
        axisBorder: {
          color: this.helperService.getColorVariable('primary'),
        },
        axisTicks: {
          color: this.helperService.getColorVariable('secondary'),
        }
      },
      grid: {
        borderColor: this.helperService.getColorVariable('primary'),
      }
    };
    this.changeDetectorRef.detectChanges();
  }

  FilterObject(value: any[], filterObj: { id?: string; account?: string; }, except = false) {
    return new CustomArrayFilterPipe().transform(value, filterObj);
  }

}
